import PageData from "../../common/ts/PageData";
import {EventBus} from "../../common/ts/events/EventBus";
import {
    AgencyPhoneButtonClickedEvent, AgencyPhoneButtonClickedEventPayload,
    AgencyPhoneModalOpenedEvent,
    AgencyPhoneModalOpenedEventPayload,
    FullPageModalOpenEvent,
    ObfuscatedElementClickedEvent,
    PhoneContactSentEvent,
    WhitelabelEvent
} from "../../common/ts/events/Events";
import AdFormService from "../../common/ts/services/AdFormService";
import {Section} from "../../common/ts/services/Section";
import HipflatForm from "./HipflatForm";

export default class HipflatPhoneModal {

    private readonly eventBus: EventBus;
    private readonly adFormService: AdFormService;
    private readonly contactModalId: string = 'phone-modal';
    private readonly form: HipflatForm;
    private alreadyOpened: boolean | null = null;

    private constructor(form: HipflatForm) {
        this.eventBus = EventBus.getInstance();
        this.adFormService = new AdFormService()
        this.form = form
        this.setupEventListeners();
    }

    static init = (pageData: PageData) => {
        const form: HTMLElement | null = document.getElementById('phone-modal')?.querySelector('#phone-modal-form') || null;
        if (form != null) {
            new HipflatPhoneModal(HipflatForm.initForm(form, pageData))
        }
    }

    setupEventListeners = () => {
        this.eventBus.subscribe(AgencyPhoneButtonClickedEvent.TYPE, (agencyPhoneButtonClickedEvent: WhitelabelEvent) => {
            const payload: AgencyPhoneButtonClickedEventPayload = (agencyPhoneButtonClickedEvent as AgencyPhoneButtonClickedEvent).payload;
            this.open({
                section: payload.section,
                pageViewId: payload.pageViewId,
                propertyAdId: payload.propertyAdId,
                pageViewType: payload.pageViewType,
            });
        });
        this.eventBus.subscribe(ObfuscatedElementClickedEvent.TYPE, (obfuscatedElementClickedEvent: WhitelabelEvent) => {
            let payload = (obfuscatedElementClickedEvent as ObfuscatedElementClickedEvent).payload;
            const section: Section = payload.section;
            if (section === Section.SECTION_ADPAGE_DESCRIPTION_VIEW_PHONE) {
                this.open({
                    section: section,
                    pageViewId: payload.pageViewId,
                    propertyAdId: payload.propertyAdId,
                    pageViewType: payload.pageViewType,
                });
            }
        });
        this.eventBus.subscribe(AgencyPhoneModalOpenedEvent.TYPE, (contactModalFormDisplayedEvent: WhitelabelEvent) => {
            const payload: AgencyPhoneModalOpenedEventPayload = (contactModalFormDisplayedEvent as AgencyPhoneModalOpenedEvent).payload;
            this.adFormService.sendApplyImpression({
                pageViewId: payload.pageViewId,
                propertyAdId: payload.propertyAdId,
                section: payload.section,
                step: 2,
                isProject: false,
            });
        });
        this.eventBus.subscribe(PhoneContactSentEvent.TYPE, event => {
            this.alreadyOpened = true;
        });
    }

    private open = ({
        section,
        pageViewId,
        propertyAdId,
        pageViewType,
    }: {
        section: Section,
        pageViewId: string,
        propertyAdId: string,
        pageViewType: string,
    }) => {
        this.form.section = section;
        // this.form.reset();
        if (this.alreadyOpened){
            this.form.managePhoneTracking();
            return;
        }
        this.eventBus.emit(new FullPageModalOpenEvent({id: this.contactModalId}));
        this.eventBus.emit(new AgencyPhoneModalOpenedEvent({
            section: section,
            pageViewId: pageViewId,
            propertyAdId: propertyAdId,
            pageViewType: pageViewType,
        }));
    }
};
